import { render, staticRenderFns } from "./AccommodationReviewItem.vue?vue&type=template&id=f73eebf6&scoped=true&"
import script from "./AccommodationReviewItem.vue?vue&type=script&lang=js&"
export * from "./AccommodationReviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73eebf6",
  null
  
)

export default component.exports